import { IAttribute, IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { OracleFusionTableDataset } from 'app/model/dataset/oracle-fusion.dataset';
import { TabularCopySource } from 'app/model/pipeline/copysource/tabular-type.copysource';

@Metamodel.model({
    name: 'OracleFusionSource',
    display: [],
    tags: {
        datasetModel: Metamodel.modelFor(OracleFusionTableDataset)
    }
})
export class OracleFusionCopySource extends TabularCopySource {
    public static readonly MODEL: IModel;
    public static readonly BICC_SAVED_JOB_LABEL: IAttribute;

    @Metamodel.attribute({ association: 'BICC_SAVED_JOB_LABEL' })
    public biccSavedJobLabel?: string;
}